module.exports = __webpack_public_path__ + "static/media/galerija_2021 (21).09cc46a7.jpg";